import { VacationType } from 'src/tabs/hooks/useVacationTypes';

export const checkVacationTypeId = (
  vacationTypes: VacationType[],
  vacationTypeName: string
) => {
  const result = vacationTypes.filter(
    (vacType) => vacType?.new_name === vacationTypeName
  );

  return result[0].new_axsvacationtypeid;
};
